import * as yup from 'yup';

const password = {
  base: yup.string().typeError('errorMessages.string')
};
password.required = password.base.required('errorMessages.required');
password.optional = password.base;

export default password;
